// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jDP9X7qP","pName":"yqRkBi0T","outOfStock":"SnYOzpfH","starWrap":"vhU9cvRq","deal":"Lsjhp64y"};